import React, { useCallback, useEffect, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { fetchBidang } from "../../api";
import { LayoutTable, LayoutThead } from "../../components/layouts/Table";
import PageLoading from "../../components/pages/Loading";
import PageNoData from "../../components/pages/NoData";
import SectionPagination from "../../components/sections/Pagination";
import { userState } from "../../storage/auth";
import { titleState } from "../../storage/pages";
import BidangCreate from "./Create";
import BidangEdit from "./Edit";
import TableNew, { Tbody, Td, Th, Thead, Tr } from "../../components/layouts/TableNew";

const BidangAkademik = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const setTitle = useSetRecoilState(titleState);
  const user = useRecoilValue(userState);

  useEffect(() => {
    setTitle("Data Bidang");
  }, [setTitle]);

  const [page, setPage] = useState(1);
  const [items, setItems] = useState({});

  const fetchData = useCallback(async () => {
    try {
      const res = await fetchBidang(page);
      setItems(res.data);
      setIsLoaded(true);
    } catch (err) {
      console.log(err);
    }
  }, [page]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (isLoaded) {
    return (
      <>
        <BidangCreate onFetchData={fetchData} />
        {items.data && items.data.length > 0 ? (
          <TableNew>
            <Thead>
              <Tr className='text-center'>
                <Th>No</Th>
                <Th>Nama Bidang</Th>
                <Th>Kriteria</Th>
                <Th>
                  <i className="fa fa-fw fa-cog"></i>
                </Th>
              </Tr>
            </Thead>
            <Tbody>
              {items.data.map((i, index) => {
                return (
                  <Tr key={index}>
                    <Td className="text-center">{items.from + index}</Td>
                    <Td>{i.nama}</Td>
                    <Td className="text-center">
                      {parseInt(i.kriteria) === 1 && "Wajib"}
                      {parseInt(i.kriteria) === 2 && "Pilihan"}
                    </Td>
                    <Td className="text-center">
                      {user.cabang === "pusat" ? (
                        <BidangEdit bidang={i} onFetchData={fetchData} />
                      ) : (
                        "-"
                      )}
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </TableNew>
        ) : (
          <PageNoData />
        )}

        <SectionPagination
          links={items.links}
          onChangePage={(res) => setPage(res)}
        />
      </>
    );
  } else {
    return <PageLoading />;
  }
};

export default BidangAkademik;
